// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"SearchInput_searchInput__2oJSl","icon":"SearchInput_icon__1G8Nl"};